import { Mutation, Action, VuexModule, Module } from "vuex-module-decorators";

/** store state model */
export interface MobileFamilyReceiveMessageState {
  functionContents: { hidden: boolean; familyRelation: string; content: string; isFinished: boolean };
  residentId: number;
  residentName: string;
  familyId: number;
  familyName: string;
  datetime: number;
  groupId: number;
  caseId: number;
  exist: boolean;
}

/**
 * ### MobileFamilyReceiveMessage store
 *
 * - store
 *   - 受信メッセージ(家族)のメッセージ情報を保持する
 * - action, mutation
 *   - 受信メッセージ(家族)のメッセージ情報を格納する
 */
@Module({ name: "mobileFamilyReceiveMessage" })
export default class MobileFamilyReceiveMessage extends VuexModule implements MobileFamilyReceiveMessageState {
  functionContents = {
    hidden: false,
    familyRelation: "",
    content: "",
    isFinished: false
  };
  residentId = -1;
  residentName = "";
  familyId = -1;
  familyName = "";
  datetime = 0;
  groupId = 0;
  caseId = 0;
  exist = false;

  /** stateのgetters */
  get mobileFamilyReceiveMessageState(): MobileFamilyReceiveMessageState {
    const state: MobileFamilyReceiveMessageState = {
      functionContents: this.functionContents,
      residentId: this.residentId,
      residentName: this.residentName,
      familyId: this.familyId,
      familyName: this.familyName,
      datetime: this.datetime,
      groupId: this.groupId,
      caseId: this.caseId,
      exist: this.exist
    };
    return state;
  }

  @Mutation
  private SET_MOBILEFAMILYRECEIVEMESSAGESTATE(state: MobileFamilyReceiveMessageState) {
    this.functionContents = state.functionContents;
    this.residentId = state.residentId;
    this.residentName = state.residentName;
    this.familyId = state.familyId;
    this.familyName = state.familyName;
    this.datetime = state.datetime;
    this.groupId = state.groupId;
    this.caseId = state.caseId;
    this.exist = true;

    return;
  }

  @Mutation
  private RESET_MOBILEFAMILYRECEIVEMESSAGESTATE() {
    this.functionContents = {
      hidden: false,
      familyRelation: "",
      content: "",
      isFinished: false
    };
    this.residentName = "";
    this.familyName = "";
    this.datetime = 0;
    this.groupId = 0;
    this.caseId = 0;
    this.exist = false;

    return;
  }

  /**
   * ### 受信メッセージ(家族)のメッセージ情報を更新する
   *
   * @param payload Actionは第一引数でしか値を渡せないので引数をまとめたオブジェクト
   */
  @Action({ rawError: true })
  public updateMobileFamilyReceiveMessageState(payload: { state: MobileFamilyReceiveMessageState }): void {
    this.SET_MOBILEFAMILYRECEIVEMESSAGESTATE(payload.state);
    return;
  }

  /**
   * ### 受信メッセージ(家族)のメッセージ情報を初期化する
   *
   * @param payload Actionは第一引数でしか値を渡せないので引数をまとめたオブジェクト
   */
  @Action({ rawError: true })
  public resetMobileFamilyReceiveMessageState(): void {
    this.RESET_MOBILEFAMILYRECEIVEMESSAGESTATE();
    return;
  }
}
